"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var ErrorLog =
/** @class */
function () {
  function ErrorLog() {
    this.testId = null;
    this.instrumentSerialNumber = null;
    this.action = null;
    this.additionalInfo = null;
    this.practice = null;
    this.user = null;
    this.reportedTimestamp = null;
    this.knownError = null;
  }

  ErrorLog.thaw = function (errorLogObj) {
    var _a;

    if (errorLogObj == null) {
      return null;
    }

    var errorLog = new ErrorLog();

    if (errorLogObj.reportedTimestamp != null) {
      errorLog.setReportedTimestamp((_a = new Date(errorLogObj.reportedTimestamp)) !== null && _a !== void 0 ? _a : null);
    }

    if (errorLogObj.testId != null) {
      errorLog.setTestId(errorLogObj.testId);
    }

    if (errorLogObj.instrumentSerialNumber != null) {
      errorLog.setInstrumentSerialNumber(errorLogObj.instrumentSerialNumber);
    }

    if (errorLogObj.action != null) {
      errorLog.setAction(errorLogObj.action);
    }

    if (errorLogObj.additionalInfo != null) {
      errorLog.setAdditionalInfo(errorLogObj.additionalInfo);
    }

    if (errorLogObj.practice != null) {
      errorLog.setPractice(errorLogObj.practice);
    }

    if (errorLogObj.user != null) {
      errorLog.setUser(errorLogObj.user);
    }

    if (errorLogObj.knownError != null) {
      errorLog.setKnownError(errorLogObj.knownError);
    }

    return errorLog;
  };

  ErrorLog.thawList = function (errorLogObjList) {
    if (errorLogObjList == null) {
      return [];
    }

    var errorLogs = new Array(errorLogObjList.length);

    for (var i = 0; i < errorLogObjList.length; i++) {
      errorLogs[i] = ErrorLog.thaw(errorLogObjList[i]);
    }

    return errorLogs;
  };

  ErrorLog.freeze = function (errorLog) {
    var _a, _b;

    if (errorLog == null) {
      return null;
    }

    var errorLogObj = {};

    if (errorLog.getReportedTimestamp() != null) {
      errorLogObj.reportedTimestamp = (_b = (_a = errorLog.getReportedTimestamp()) === null || _a === void 0 ? void 0 : _a.toISOString()) !== null && _b !== void 0 ? _b : null;
    }

    if (errorLog.getTestId() != null) {
      errorLogObj.testId = errorLog.getTestId();
    }

    if (errorLog.getInstrumentSerialNumber() != null) {
      errorLogObj.instrumentSerialNumber = errorLog.getInstrumentSerialNumber();
    }

    if (errorLog.getAction() != null) {
      errorLogObj.action = errorLog.getAction();
    }

    if (errorLog.getAdditionalInfo() != null) {
      errorLogObj.additionalInfo = errorLog.getAdditionalInfo();
    }

    if (errorLog.getPractice() != null) {
      errorLogObj.practice = errorLog.getPractice();
    }

    if (errorLog.getUser() != null) {
      errorLogObj.user = errorLog.getUser();
    }

    if (errorLog.getKnownError() != null) {
      errorLogObj.knownError = errorLog.getKnownError();
    }

    return errorLogObj;
  };

  ErrorLog.freezeList = function (errorLogs) {
    if (errorLogs == null) {
      return [];
    }

    var errorLogObjList = new Array(errorLogs.length);

    for (var i = 0; i < errorLogs.length; i++) {
      errorLogObjList[i] = ErrorLog.freeze(errorLogs[i]);
    }

    return errorLogObjList;
  };
  /* -------------------------
   -------------------------
   -------- SETTERS --------
   -------------------------
   ------------------------- */


  ErrorLog.prototype.setTestId = function (testId) {
    this.testId = testId;
  };

  ErrorLog.prototype.setInstrumentSerialNumber = function (instrumentSerialNumber) {
    this.instrumentSerialNumber = instrumentSerialNumber;
  };

  ErrorLog.prototype.setAction = function (action) {
    this.action = action;
  };

  ErrorLog.prototype.setAdditionalInfo = function (additionalInfo) {
    this.additionalInfo = additionalInfo;
  };

  ErrorLog.prototype.setPractice = function (practice) {
    this.practice = practice;
  };

  ErrorLog.prototype.setUser = function (user) {
    var userObj = {};

    if (user == null) {
      return;
    }

    if (user.id != null) {
      userObj.id = user.id;
    }

    if (user.firstName != null) {
      userObj.firstName = user.firstName;
    }

    if (user.lastName != null) {
      userObj.lastName = user.lastName;
    }

    this.user = userObj;
  };

  ErrorLog.prototype.setReportedTimestamp = function (reportedTimestamp) {
    this.reportedTimestamp = reportedTimestamp;
  };

  ErrorLog.prototype.setKnownError = function (knownError) {
    this.knownError = knownError;
  };
  /* -------------------------
    -------------------------
    -------- GETTERS --------
    -------------------------
    ------------------------- */


  ErrorLog.prototype.getTestId = function () {
    return this.testId;
  };

  ErrorLog.prototype.getInstrumentSerialNumber = function () {
    return this.instrumentSerialNumber;
  };

  ErrorLog.prototype.getAction = function () {
    return this.action;
  };

  ErrorLog.prototype.getAdditionalInfo = function () {
    return this.additionalInfo;
  };

  ErrorLog.prototype.getPractice = function () {
    return this.practice;
  };

  ErrorLog.prototype.getUser = function () {
    return this.user;
  };

  ErrorLog.prototype.getReportedTimestamp = function () {
    return this.reportedTimestamp;
  };

  ErrorLog.prototype.getKnownError = function () {
    return this.knownError;
  };
  /* -------------------------
    -------------------------
    -------- HELPERS --------
    -------------------------
    ------------------------- */


  ErrorLog.prototype.getUserFullName = function () {
    var _a, _b;

    return "".concat((_a = this.user) === null || _a === void 0 ? void 0 : _a.firstName, " ").concat((_b = this.user) === null || _b === void 0 ? void 0 : _b.lastName);
  };

  ErrorLog.prototype.getErrorCode = function () {
    var _a;

    return (_a = this.knownError) === null || _a === void 0 ? void 0 : _a.code;
  };

  ErrorLog.prototype.getPraticeName = function () {
    var _a;

    return (_a = this.practice) === null || _a === void 0 ? void 0 : _a.name;
  };

  ErrorLog.prototype.getPracticeId = function () {
    var _a;

    return (_a = this.practice) === null || _a === void 0 ? void 0 : _a.id;
  };

  ErrorLog.prototype.getPracticeName = function () {
    var _a;

    return (_a = this.practice) === null || _a === void 0 ? void 0 : _a.name;
  };

  return ErrorLog;
}();

var _default = ErrorLog;
exports.default = _default;